// Constants
import { TYPES } from '../types/types.constants';
import { initialStateTransaction } from './initial.state';

export const transactionReducer = (state = initialStateTransaction, action) => {

    switch (action.type) {

        case TYPES.TRANSACTION.SET_ENTITY:

            return {
                ...state,
                entity: {
                    ...action.payload
                }
            }

        case TYPES.TRANSACTION.METADATA:

            return {
                ...state,
                metadata: {
                    ...action.payload
                }
            }

        case TYPES.TRANSACTION.ACTIVATED:
            return {
                ...state,
                activated: {
                    ...action.payload
                }
            }

        case TYPES.TRANSACTION.UPDATE:
            return {
                ...state,
                activated: {
                    ...action.payload
                }
            }

        case TYPES.TRANSACTION.LIST:
            return {
                ...state,
                list: {
                    items: [...state.list.items, ...action.payload.transactions],
                    metadata: {
                        ...action.payload.metadata
                    }
                }
            }

        case TYPES.TRANSACTION.RESET:
            return {
                ...state,
                entity: initialStateTransaction.entity,
                activated: initialStateTransaction.activated,
                list: initialStateTransaction.list,
                metadata: initialStateTransaction.metadata
            }

        case TYPES.APP.RESET:
            return {
                ...initialStateTransaction
            }

        default:
            return state;
    }
};